import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editar-servicio-area',
  templateUrl: './editar-servicio-area.component.html',
  styleUrls: ['./editar-servicio-area.component.css']
})
export class EditarServicioAreaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
